module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.624/js/sprocket_white.svg"